import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=30dcafbb"
import script from "./textArea.vue?vue&type=script&lang=ts"
export * from "./textArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports